import { X } from "lucide-react";
import React, { ReactNode } from "react";

interface ModalProps {
  isOpen?: boolean;
  onClose: () => void;
  title: string | ReactNode;
  children: ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
}

const Modal: React.FC<ModalProps> = ({
  isOpen = true,
  onClose,
  title,
  children,
  size = "md",
}) => {
  if (!isOpen) return null;

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
  };

  const renderTitle = () => {
    if (typeof title === "string") {
      return <h2 className="text-xl font-bold text-gray-900">{title}</h2>;
    }
    return title;
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 transition-opacity"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-lg shadow-xl w-full ${sizeClasses[size]} transform transition-all`}
        onClick={handleContentClick}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          {renderTitle()}
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};

export default Modal;
